import { workspaceApi } from "../cnb/apis";
import { Workspace } from "../lib/cnb/api/public";

const api = {
  getWorkspaces: async (): Promise<Workspace[]> => workspaceApi.getAll(),
};

export default api;
